import { render, staticRenderFns } from "./NfcTransaction.vue?vue&type=template&id=12d7c393&scoped=true"
import script from "./NfcTransaction.vue?vue&type=script&lang=js"
export * from "./NfcTransaction.vue?vue&type=script&lang=js"
import style0 from "./NfcTransaction.vue?vue&type=style&index=0&id=12d7c393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7c393",
  null
  
)

export default component.exports